import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText,
  FDClickableText, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { RoadmapGoals } from '../GoalsByTimeStepTemplate/RoadmapGoals';

const ListSection = () => {
  const { resource } = useMetaLayoutContext();
  const [showOutOfFocusGoals, setShowOutOfFocusGoals] = React.useState(false);

  const outOfFocusGoals = resource.attr('outOfFocusGoals').resources().list();
  const focusGoals = resource.attr('focusGoals').resources().list();

  return (
    <FDStack direction={'column'} spacing={4}>
      <FDStack direction={'column'} spacing={1}>
        <MetaControlField attr={'focusGoalsTitle'} />
        <MetaControlField attr={'focusGoalsSubtitle'} />
      </FDStack>
      <RoadmapGoals
        goals={focusGoals}
        showDetails={false}
        showTooltip={false}
        showProgress
      />
      { outOfFocusGoals.length > 0 ? (
        <FDBodyText
          value={
            <FDClickableText
              appearance={'standalone'}
              onClick={() => setShowOutOfFocusGoals(!showOutOfFocusGoals)}
              label={showOutOfFocusGoals ? 'Hide out of focus goals' : 'Show all goals'}
            />
        }
          color={'textSecondary'}
        />
      ) : null}
      {
        showOutOfFocusGoals ? (
          <FDStack direction={'column'} spacing={2}>
            <MetaControlField attr={'outOfFocusGoalsTitle'} />
            <RoadmapGoals
              goals={outOfFocusGoals}
              showDetails={false}
              showTooltip={false}
              showProgress
            />
          </FDStack>
        ) : null
      }
    </FDStack>
  );
};

export default ListSection;
